import { render, staticRenderFns } from "./header-tab.vue?vue&type=template&id=6883f770&scoped=true&"
import script from "./header-tab.vue?vue&type=script&lang=ts&"
export * from "./header-tab.vue?vue&type=script&lang=ts&"
import style0 from "./header-tab.vue?vue&type=style&index=0&id=6883f770&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883f770",
  null
  
)

export default component.exports